import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { EndpointConstants } from '../constants/endpoint.constants';

@Injectable()
export class ArkikHeadersInterceptor implements HttpInterceptor {
  constructor(private cookieService: CookieService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // 1. Criterio de filtrado: Verifica si la URL pertenece a APIM u otros servicios de la nueva arquitectura
    const isTargetEndpoint =
      request.url.includes(environment.APIM) ||
      request.url.includes('arkik-ordertaking') ||
      request.url.includes('arkik-customermanagement');

    // Si NO es un endpoint objetivo, deja pasar la petición 100% intacta (Cero impacto en el monolito)
    if (!isTargetEndpoint) {
      return next.handle(request);
    }

    // 2. Prepara la clonación e inyección de headers requeridos
    let headers = request.headers;

    // APIM Key
    if (!headers.has('Ocp-Apim-Subscription-Key')) {
      headers = headers.set('Ocp-Apim-Subscription-Key', EndpointConstants.OCP_APIM);
    }

    // Content-Type por defecto (excepto cuando se envían archivos/FormData)
    if (!headers.has('Content-Type') && !(request.body instanceof FormData)) {
      headers = headers.set('Content-Type', 'application/json');
    }

    // Multi-tenant y contexto de sesión desde Cookies (si existen)
    const userGuid = this.cookieService.get(environment.UserGuid);
    const companyGuid = this.cookieService.get(environment.CompanyGuid);

    if (userGuid && !headers.has('UserGuid')) {
      headers = headers.set('UserGuid', userGuid);
    }

    if (companyGuid && !headers.has('CompanyGuid')) {
      headers = headers.set('CompanyGuid', companyGuid);
    }

    // Clonar la petición con los headers actualizados
    const clonedRequest = request.clone({ headers });
    return next.handle(clonedRequest);
  }
}
